var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuex-table',{attrs:{"fields":_vm.fields,"auto_start":true,"table_store":"prices/rates/table","tooltip_text":_vm.$t('prices.common.info.billing_terms_tooltip')},scopedSlots:_vm._u([{key:"billingTerms",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.mc)+" / "+_vm._s(item.ci)+" / "+_vm._s(item.ft)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }